import React, { useEffect, useState } from 'react';
import AuditLogTable from '../../../components/tables/AuditLogTable';
import { useAuditLogApi } from '../../../hooks/useAuditLogApi';
import { AuditLogDTO } from '../../../services/apiClient';

interface InvoiceBatchAuditLogPanelProps {
  batchId: string;
}

const InvoiceBatchAuditLogPanel: React.FC<InvoiceBatchAuditLogPanelProps> = ({ batchId }) => {
  const { search: searchAuditLogs, isLoading } = useAuditLogApi();
  const [auditLogs, setAuditLogs] = useState<AuditLogDTO[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchAuditLogs = async () => {
      if (!batchId) return;
      try {
        const response = await searchAuditLogs({
          page: currentPage,
          pageSize,
          sortBy: 'CreatedUtc',
          sortDescending: true,
          filters: {
            tableName: 'InvoiceBatch',
            recordId: batchId,
          },
        });

        if (response?.success && response.data) {
          setAuditLogs((response.data.results as AuditLogDTO[]) || []);
          setTotalPages(Math.ceil((response.data.totalCount ?? 0) / pageSize));
        }
      } catch (error) {
        console.error('Error fetching batch audit logs:', error);
      }
    };

    fetchAuditLogs();
  }, [batchId, currentPage, pageSize]);

  return (
    <AuditLogTable
      data={auditLogs}
      currentPage={currentPage}
      totalPages={totalPages}
      setCurrentPage={setCurrentPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default InvoiceBatchAuditLogPanel;
